<template>
  <div class="page">
    <header class="header">
      <span class="header-title">Docker配信システム</span>
      <button class="btn-logout" @click="logout">ログアウト</button>
    </header>

    <main class="main">
      <h2 class="page-title">メニュー</h2>
      <p class="welcome">ようこそ、{{ username }} さん</p>

      <div class="menu-cards">
        <div class="menu-card" @click="$router.push('/upload')">
          <div class="card-icon">📦</div>
          <div class="card-label">Dockerイメージ<br />アップロード</div>
        </div>
        <div class="menu-card" @click="$router.push('/manage')">
          <div class="card-icon">🗂</div>
          <div class="card-label">Dockerイメージ<br />管理</div>
        </div>
        <button type="button" class="menu-card" @click="$router.push('/users')">
          <div class="card-icon" aria-hidden="true">👥</div>
          <div class="card-label">ユーザ管理</div>
        </button>
      </div>
    </main>
  </div>
</template>

<script>
import api from '../api.js';

export default {
  name: 'MenuView',
  data() {
    return { username: '' };
  },
  async created() {
    try {
      const res = await api.get('/api/admin/me');
      this.username = res.data.username;
    } catch {
      this.$router.push('/login');
    }
  },
  methods: {
    async logout() {
      await api.post('/api/admin/logout');
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #f0f2f5;
}
.header {
  background: #1f2328;
  color: #fff;
  padding: 0 24px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-title {
  font-size: 16px;
  font-weight: 700;
}
.btn-logout {
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
  padding: 5px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}
.btn-logout:hover {
  background: rgba(255, 255, 255, 0.1);
}
.main {
  max-width: 900px;
  margin: 60px auto;
  padding: 0 16px;
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 6px;
}
.welcome {
  color: #57606a;
  font-size: 14px;
  margin-bottom: 40px;
}
.menu-cards {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}
.menu-card {
  flex: 1;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: box-shadow 0.15s;
  min-width: 200px;
  font: inherit;
  color: inherit;
}
.menu-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.09);
}
.card-icon {
  font-size: 40px;
  margin-bottom: 16px;
}
.card-label {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
}
</style>
